import classNames from 'classnames';
import { ErrorMessage, Field, useFormikContext } from 'formik';
import React, { memo } from 'react';
import { FormFieldBlokProps } from '../FormFields/FormFieldBlokProps.interface';
import StampDutyFormField from './StampDutyFormField';
import SbImage from '../SbImage/SbImage';
import { CountryType } from './StampDutyCalculator';
import { capitalize } from '../../utils/capitalize/capitalize';

interface StampDutyFormFieldCheckboxSelectProps {
  options: CountryType[];
  country: CountryType;
  setCountry: (country: CountryType) => void;
}

const StampDutyFormFieldCheckboxSelect: React.FC<
  StampDutyFormFieldCheckboxSelectProps
> = ({ options, country, setCountry }) => {
  const getFlagURL = (country: CountryType) => {
    if (country === CountryType.ENGLAND) return "url('/svgs/england-flag.svg')";
    if (country === CountryType.WALES) return "url('/svgs/wales-flag.svg')";
    return "url('/svgs/scotland-flag.svg')";
  };

  return (
    <>
      <ul className="grid grid-cols-12 gap-x-6 gap-y-6 sm:gap-y-0 pt-2">
        {options.map((option: CountryType, idx) => (
          <li
            key={option}
            className={classNames(
              'p-6 w-full flex items-center justify-start flex-col gap-y-3 sm:max-w-[236px] border-[#8E9899] border rounded-[8px] cursor-pointer transition-all',
              {
                'bg-button/primary-bg text-system/white': option === country,
                'bg-system/white': option !== country,
                'col-span-6 sm:col-span-4': idx === 1 || idx === 2,
                'col-span-12 sm:col-span-4': idx === 0,
              }
            )}
            onClick={() => setCountry(option)}
          >
            <div
              style={{ backgroundImage: getFlagURL(option) }}
              className="h-[48px] w-[64px] bg-no-repeat transition-all bg-cover"
            ></div>
            <label
              htmlFor={option}
              className={classNames('font-dm-sans font-bold', {
                'text-system/white': option === country,
                'text-text/body': option !== country,
              })}
            >
              {capitalize(option)}
            </label>
            <div
              className={classNames(
                'w-[18px] h-[18px] border-2 rounded-full flex justify-center items-center',
                {
                  'border-system/white': option === country,
                  'border-text/body-tint': option !== country,
                }
              )}
            >
              <div
                className={classNames(
                  'w-[8px] h-[8px] rounded-full bg-system/white'
                )}
              ></div>
            </div>
          </li>
        ))}
      </ul>
    </>
  );
};

export default memo(StampDutyFormFieldCheckboxSelect);
